import React from 'react';

const ErrorModal = () => {
    return (
        <div className="ct-step__modal-wrapper">
            <div className="ct-step__loading-modal">
                <div className="ct-step__loading-modal-title">
                  Er is een onverwacht probleem opgetreden
                </div>

                <div className="ct-step__loading-modal-text ct-step__loading-modal-text__d-inline">
                   Klik <a href={window.location.href}>hier</a> om de berekening opnieuw te starten. Onze excuses voor het ongemak.
                </div>

            </div>
        </div>
    );
};

export default ErrorModal;
